import useSWRInfinite from 'swr/infinite'
import { jsonGetFetcher } from '../src/fetchers'

function useFeed (token, type, id) {
  const pageSize = 50
  const getKey = (pageIndex, previousPageData) => {
    if (!token || !id) return null
    if (pageIndex && !previousPageData.startKey) return null // reached the end
    let url = `${process.env.API}/feeds/${type === 'challenge' ? 'challenge' : 'group'}/${id}?limit=${pageSize}`
    if (previousPageData && previousPageData.startKey) {
      url += `&startKey=${previousPageData?.startKey}`
    }
    return [url, token]
  }

  const { data, size, setSize, error, mutate, isLoading, isValidating } = useSWRInfinite(getKey, jsonGetFetcher, {
    refreshWhenHidden: false,
    refreshWhenOffline: false,
    revalidateFirstPage: true,
    dedupingInterval: 20000,
    keepPreviousData: true,
    focusThrottleInterval: 20000
  })

  if (!data && !error && !isLoading) {
    return {
      isLoading,
      feed: [],
      error: false
    }
  }

  if (error) {
    if (error.status === 401) {
      // user hook will handle logout, just return empty data
      return { isLoading, feed: [], error: 'Unauthorized' }
    }
    return { feed: [], errorStatus: error.status, error: error.message, isLoading }
  }

  const isLoadingInitialData = !data && !error;
  const isEnd = data && data.length ? Boolean(!data[data.length - 1].startKey) : false
  const total = data ? data.reduce((acc, page) => acc + page?.results?.length, 0) : 0
  const isLoadingMore = !isEnd && (isLoadingInitialData || (size > 0 && data && typeof data[size - 1] === 'undefined'));

  return {
    isLoading,
    isLoadingMore,
    data,
    setSize,
    size,
    pageSize,
    isEnd,
    error,
    mutate,
    total
  }
}

export default useFeed
